<template>
    <div id="services" class="home-services">
        <h2 class="home-services__title">Testachats, à votre service</h2>
        <!--<div class="home-service-content">-->
        <!--    <div class="service" v-for="(service, serviceKey) in services" :key="serviceKey">-->
        <!--        <img :src="service.img" :alt="service.altimg"-->
        <!--             data-aos="fade-up" :data-aos-delay="200*(serviceKey+1)" data-aos-once="true">-->
        <!--        <h3 class="service-title" v-html="service.title"></h3>-->
        <!--        <p class="service-text" v-html="service.text"></p>-->
        <!--    </div>-->
        <!--</div>-->
        <div class="home-service-carousel">
            <hooper :settings="settings" @slide="updateCarousel" ref="servicecarousel">
                <slide v-for="(service, serviceKey) in services" :key="serviceKey">
                    <img :src="service.img" :alt="service.altimg"
                         data-aos="fade-up" :data-aos-delay="200*(serviceKey+1)" data-aos-once="true">
                    <h3 class="service-title" v-html="service.title"></h3>
                    <p class="service-text" v-html="service.text"></p>
                </slide>
                <pagination slot="hooper-addons" mode="fraction"></pagination>
                <navigation slot="hooper-addons">
                    <template #hooper-prev>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                            <g fill="none" fill-rule="evenodd" stroke="#FF8600" transform="translate(1 1)">
                                <path fill="#FF8600" fill-rule="nonzero" stroke-width=".5"
                                      d="M17.7 14.2c.3-.3.8-.3 1 0 .4.3.4.8 0 1l-5.2 5.3h17.4c.4 0 .8.3.8.7 0 .4-.4.7-.8.7H13.5l5.3 5.3c.3.3.3.7 0 1-.3.3-.8.3-1 0l-6.6-6.5a.7.7 0 010-1l6.5-6.5z"/>
                                <circle cx="21" cy="21" r="21"/>
                            </g>
                        </svg>
                    </template>
                    <template #hooper-next>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                            <g fill="none" fill-rule="evenodd" stroke="#FF8600" transform="matrix(-1 0 0 1 43 1)">
                                <path fill="#FF8600" fill-rule="nonzero" stroke-width=".5"
                                      d="M17.7 14.2c.3-.3.8-.3 1 0 .4.3.4.8 0 1l-5.2 5.3h17.4c.4 0 .8.3.8.7 0 .4-.4.7-.8.7H13.5l5.3 5.3c.3.3.3.7 0 1-.3.3-.8.3-1 0l-6.6-6.5a.7.7 0 010-1l6.5-6.5z"/>
                                <circle cx="21" cy="21" r="21"/>
                            </g>
                        </svg>
                    </template>
                </navigation>
            </hooper>
        </div>
        <ScrollLink link="#trusts" styleType="squared" arrow="orange">faites confiance à test achats</ScrollLink>
    </div>
</template>

<script>
import {Hooper, Slide, Pagination, Navigation} from 'hooper';
import 'hooper/dist/hooper.css';
import ScrollLink from "../ScrollLink";

export default {
    name: "HomeService",
    components: {
        Hooper, Slide, Pagination, Navigation, ScrollLink
    },
    data() {
        return {
            services: [
                {
                    img: '/images/fr_multigift/service1.jpg',
                    altimg: '',
                    title: 'CONSEILS JURIDIQUES : <br> 80% de litiges résolus',
                    text: 'Un conflit avec une entreprise ? Introduisez une plainte via notre plateforme. La signature de Testachats donne du poids à votre réclamation et accélère la réaction de l’enseigne de 4 jours en moyenne. Et si cela ne suffit pas, 50 avocats sont à votre disposition pour vous aider à faire valoir vos droits. '
                },
                {
                    img: '/images/fr_multigift/service2.jpg',
                    altimg: '',
                    title: '1254 € d\'économies par an',
                    text: 'C\'est l’économie maximale annuelle réalisée par nos membres grâce à nos comparateurs, nos achats groupés et nos réductions exclusives... Et tout cela sans se priver, mais en appliquant simplement les bons conseils et en évitant les frais inutiles.'
                },
                {
                    img: '/images/fr_multigift/service3.jpg',
                    altimg: '',
                    title: 'Des choix sûrs et personnalisés',
                    text: 'Changer de fournisseur d’énergie, acheter un lave-linge ou choisir votre mutuelle ? Nos sélecteurs vous guident vers le produit le mieux adapté à vos priorités. Une question spécifique ? Isolation, primes énergie, antivirus, déclaration fiscale... Appelez-nous ! Nos spécialistes vous répondront personnellement.'
                },
                {
                    img: '/images/fr_multigift/service4.jpg',
                    altimg: '',
                    title: 'Les dernières tendances conso',
                    text: 'Chaque jour, nos experts décortiquent toute l’actualité conso et juridique : des informations concises et toujours à portée de main, que vous retrouverez dans nos magazines papier et numérique, mais aussi sur notre site web. Sans oublier nos astuces pour éviter les arnaques ! Enfin, notre catalogue de guides vous propose des thématiques traitées en profondeur : assurances, allergies, cloud... Approfondissez les sujets qui vous intéressent, quand vous le voulez.'
                },
                {
                    img: '/images/fr_multigift/service5.jpg',
                    altimg: '',
                    title: 'Chaque année, des victoires pour le consommateur',
                    text: 'Plus d’un millier de consommateurs indemnisés, le feu vert pour le nutriscore, la fin des frais de roaming dans les pays de l’Union européenne, une réduction de 20% des émissions de CO2 d’ici 2025 et de 40% d’ici 2030 obtenue au Parlement européen grâce à un travail intensif de lobbyisme mené avec le Bureau Européen des Consommateurs... Soutenir Testachats, c’est rendre toutes ces victoires possibles.'
                },
                {
                    img: '/images/fr_multigift/service6.jpg',
                    altimg: '',
                    title: 'La santé et l’alimentation sous la loupe de Test Santé',
                    text: 'Votre mutuelle est-elle encore adaptée à votre situation actuelle ? Vérifiez-le grâce à notre comparateur de mutualités. Des doutes concernant un médicament ? Notre banque de données médicaments vous renseigne sur son indication, son efficacité et les alternatives éventuelles. Test Santé, c’est une aide concrète pour votre santé au quotidien.'
                },
                {
                    img: '/images/fr_multigift/service7.jpg',
                    altimg: '',
                    title: 'Vous changez de fournisseur ? On s\'occupe de tout ',
                    text: 'Vous voudriez changer de fournisseur d’énergie ou de téléphonie sans vous encombrer de formalités ? Signalez-le-nous en ligne ou par téléphone. Test Achats prend toutes les démarches en charge. À vous la liberté !'
                },
                {
                    img: '/images/fr_multigift/service8.jpg',
                    altimg: '',
                    title: 'Des réductions exclusives pour alléger votre budget voiture ',
                    text: 'Économisez à la pompe et à la borne grâce à la carte carburant de Testachats. Des réductions valables dans 850 stations-service et de recharge électrique. Faites également des choix plus avantageux en matière d’assurances auto et de pneus grâce à nos tests comparatifs. '
                },
            ],
            settings: {
                infiniteScroll: true,
                wheelControl: false,
                breakpoints: {
                    1000: {
                        itemsToShow: 2,
                    }
                }
            }
        }
    },
    methods: {
        slidePrev() {
            this.$refs.servicecarousel.slidePrev();
        },
        slideNext() {
            this.$refs.servicecarousel.slideNext();
        },
        updateCarousel(payload) {
            this.myCarouselData = payload.currentSlide;
        }
    },
}
</script>

<style scoped>

</style>
